/* global maplibregl */

Apt.fn.extend('maps', {
	/**
	 * Create map tooltip
	 *
	 * @param {Object} options
	 * @returns {Object}
	 */
	showTooltip(options) {
		const scope = this;
		const priv = scope.$private;

		if (
			priv.tooltip &&
			options.id &&
			priv.tooltip.id === options.id
		) {
			return;
		}

		let className = 'map-popup';

		if (options.class) {
			className += ' ' + options.class;
		}

		scope.hideTooltip();

		const popup = new maplibregl.Popup({
			className: className,
			closeButton: false,
			closeOnClick: false,
			maxWidth: 'none',
			offset: 4,
			padding: 50
		});

		if (options.id) {
			scope.map.setFeatureState({
				id: options.id,
				source: 'points'
			}, {
				open: true
			});
		}

		popup.setLngLat(options.center)
			.setDOMContent(options.content)
			.addTo(scope.map);

		options.popup = popup;

		priv.tooltip = options;

		if ($.screen.size() > 2 && window.innerHeight > 480) {
			const point = scope.map.project(popup.getLngLat());
			const height = popup.getElement().offsetHeight;

			if (point.y < height) {
				const shift = scope.map.getCanvasContainer().offsetHeight - point.y;
				const offset = height + 82;

				if (shift < offset) {
					scope.map.panBy([0, offset - shift], {
						duration: 400
					});
				}
			}
		}

		return popup;
	},

	/**
	 * Clear active tooltips
	 */
	hideTooltip() {
		const priv = this.$private;

		if (! priv.tooltip) {
			return;
		}

		$.exec(priv.tooltip.onHide);

		priv.tooltip.popup.remove();

		if (priv.tooltip.id) {
			priv.map.removeFeatureState({
				id: priv.tooltip.id,
				source: 'points'
			}, 'open');
		}

		priv.tooltip = null;
	}
});